module.exports = __webpack_public_path__ + "img/thumbnail_ManedWolf_f_normal.c31eb326.png";